import ResizableScene from "../core/ResizableScene";

export default class SpriteSheetAssist {
    static createAnim(scene: ResizableScene, key: string, sheetKey: string, framePrefix: string, start: number, end: number, zeroPad: number, repeat = -1): false | Phaser.Animations.Animation {
        if (scene.anims.exists(key)) scene.anims.remove(key);
        const anim = scene.anims.create({
            key: key,
            frames: scene.anims.generateFrameNames(sheetKey, {prefix: framePrefix, start: start, end: end, zeroPad: zeroPad}),
            repeat: repeat,
        });

        return anim;
    }
}